import { isValidValidationModel, ValidationModels } from '@alliander-fe/validation';

export const validateInput = (value: string, methods: Array<ValidationModels[0] | undefined>) => {
  const filteredMethods = methods.filter((method) => method !== undefined);

  for (const method in filteredMethods) {
    return isValidValidationModel(filteredMethods[method], value);
  }
};
